const CHUNK_ERROR_PATTERNS = [
  /Loading chunk \d+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /Loading CSS chunk .* failed/i,
  /Importing a module script failed/i,
];

export const CHUNK_RELOAD_KEY = 'chunk_reload_attempted';

export function clearChunkReloadAttempt() {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  } catch {
    // sessionStorage indisponível (SSR / modo privado restrito)
  }
}

function isChunkLoadError(message) {
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message || ''));
}

function tryRecoverFromChunkError() {
  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      return;
    }
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  } catch {
    return;
  }

  const url = new URL(window.location.href);
  url.searchParams.set('_r', String(Date.now()));
  window.location.replace(url.toString());
}

export function setupChunkErrorRecovery() {
  clearChunkReloadAttempt();

  window.addEventListener('error', (event) => {
    if (isChunkLoadError(event?.message)) {
      tryRecoverFromChunkError();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const message = event?.reason?.message || String(event?.reason || '');
    if (isChunkLoadError(message)) {
      tryRecoverFromChunkError();
    }
  });
}
